import React from "react";

import { VisibilityContext } from "react-horizontal-scrolling-menu";
import { ItemCarrousel } from "../styles";

interface CardProps {
  disabled?: boolean;
  onClick: Function;
  selected: boolean;
  title: string;
  itemId: string;
  src: string;
  dragUrl: React.MutableRefObject<any>;
}

export function Card({
  onClick,
  selected,
  title,
  itemId,
  src,
  dragUrl
}: CardProps) {
  return (
    <ItemCarrousel
      draggable
      style={{ cursor: "grab" }}
      onDragStart={(e: any) => {
        dragUrl.current = e.target;
      }}
      src={src}
      alt={`template#@@#${itemId}`}
    />
  );
}
